"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _vue = require("vue");

var _uesSheetMusicPlayerOptions = _interopRequireDefault(require("../../hooks/uesSheetMusicPlayerOptions"));

var _utils = require("../../utils");

var _dataMap = require("../../utils/dataMap");

var _types = require("../types");

var _useMediaTool2 = _interopRequireDefault(require("./useMediaTool"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var _default = function _default(props, loadObj, isPresetting, alertTips, sheetMusicBusiness, sheetMusicEl, playScoreParams, initPlayScore, setIsRecordScoreing) {
  var _useSheetMusicPlayerO = (0, _uesSheetMusicPlayerOptions.default)(),
      loadFluidsynthjsSoundFont = _useSheetMusicPlayerO.loadFluidsynthjsSoundFont;

  var _useMediaTool = (0, _useMediaTool2.default)(),
      handleTempoAndPitch = _useMediaTool.handleTempoAndPitch,
      tempoPitchSoundUrl = _useMediaTool.tempoPitchSoundUrl,
      tempoPitchProgress = _useMediaTool.tempoPitchProgress,
      tempoPitchIng = _useMediaTool.tempoPitchIng,
      awaitHandleTempoAndPitch = _useMediaTool.awaitHandleTempoAndPitch;

  (0, _vue.provide)('handleTempoAndPitch', handleTempoAndPitch);
  (0, _vue.provide)('tempoPitchIng', tempoPitchIng);
  var preFetchAudioOK = {
    oriAudioOk: (0, _vue.reactive)({
      result: true,
      fetching: false
    }),
    accAudioOk: (0, _vue.reactive)({
      result: true,
      fetching: false
    })
  };
  var jsBridge = window.WebViewJavascriptBridge; // const isPresetting = ref<any>(props.isPreset);

  (0, _vue.provide)('isPresetting', isPresetting);
  var isPlaying = (0, _vue.ref)(false); // 是否处于播放过程

  var isPlayingPrepose = (0, _vue.ref)(false); // 是不是处于播放前置操作

  var playMode = (0, _vue.ref)(props.playMode);
  var playState = (0, _vue.ref)(_types.PlayState.stop);
  var currentPlayerToolType = null;
  var duration = (0, _vue.ref)(0);
  var currentTime = (0, _vue.ref)(0);
  var dragStartTime = (0, _vue.ref)(undefined);
  var areaSelect = (0, _vue.ref)(false);
  var openAreaRange = []; // 点选

  var closeAreaRange = (0, _vue.ref)([]); // AB选段

  var isAreaSelectCurrent = (0, _vue.ref)(true); // AB选段是否正确

  var ABErrorTips = (0, _vue.ref)('');
  var asRhythm = (0, _vue.ref)(false); // 是否为节奏模式

  var playParms = (0, _vue.reactive)({
    song: _lodash.default.cloneDeep(props.song) || {},
    isBeat: false,
    isPreReadyTime: true,
    isNoVolume: false,
    isRhythm: false,
    keySignature: undefined,
    sourcekeySignature: undefined,
    partInfo: [],
    speed: undefined,
    sourceSpeed: undefined,
    tempo: 1,
    pitchSemitones: 0,
    fullSheet: false,
    showLyrics: true,
    showMetronomeSignature: true,
    closeAreaSelection: false,
    colvin: false,
    meodly: false,
    rollCall: false,
    displayMode: localStorage.getItem('displayMode') ? +localStorage.getItem('displayMode') : 0 // 显示模式

  });
  var isPlayScore = false;
  var accAudio = (0, _vue.ref)(undefined);
  var startTime = (0, _vue.ref)(0);
  var preReadyTime = (0, _vue.ref)(0);
  var playEvents = (0, _vue.ref)({
    ON_INIT: function ON_INIT(playerTool) {
      console.log('ON_INIT'); // 点选评分过程中，不能点选
      // playerTool.plugin.$openAreaSelection.enable();

      initSheetPlugin(playerTool.plugin);
    },
    ON_PERPARE: function ON_PERPARE(playerTool) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('ON_PERPARE');
                isPlaying.value = true; // 点选评分过程中，不能点选

                isPlayScore ? playerTool.plugin.$openAreaSelection.disable() : playerTool.plugin.$openAreaSelection.enable(); // playerTool.plugin.$openAreaSelection.enable();

                initSheetPlugin(playerTool.plugin);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    ON_START: function ON_START(_ref) {
      var playerTool = _ref.playerTool,
          _startTime = _ref.startTime,
          _preReadyTime = _ref.preReadyTime;

      var _a;

      console.log('ON_START', _startTime, _preReadyTime);
      accAudio.value = undefined;
      isPlaying.value = true;
      startTime.value = _startTime;
      preReadyTime.value = _preReadyTime;
      initSheetPlugin(playerTool.plugin);
      resetOpenAreaSelection();
      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$colvinMelodyRender.setMelodyAnimateEnable(true);

      if (isPlayScore) {
        playerTool.plugin.$openAreaSelection.state.running && playerTool.plugin.$openAreaSelection.disable();
      }
    },
    ON_PAUSE: function ON_PAUSE() {
      console.log('ON_PAUSE');
      isPlaying.value = true;
    },
    ON_CONTINUE: function ON_CONTINUE(playerTool) {
      console.log('ON_CONTINUE');
      isPlaying.value = true;
      initSheetPlugin(playerTool.plugin);
    },
    ON_STOP: function ON_STOP(playerTool) {
      var _a;

      console.log('ON_STOP');
      var recorder = isPlayScore ? (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.recorder : undefined;

      if (recorder) {
        recorder.onprogress = undefined;
      }

      isPlaying.value = false;
      playState.value = _types.PlayState.stop;
      resetPlayTime();
      playerTool.plugin.$highlight.disable();

      if (playParms.meodly) {
        playerTool.plugin.$colvinMelodyRender.setMelodyAnimateEnable(true);
        playerTool.plugin.$colvinMelodyRender.unPauseMelodyAnimate();
        playerTool.plugin.$colvinMelodyRender.showMelodyToAnimate();
      }

      if (isPlayScore && !playParms.closeAreaSelection) {
        playerTool.plugin.$openAreaSelection.enable();
      }
    },
    ON_TIME_UPDATE: function ON_TIME_UPDATE(_ref2) {
      var playerTool = _ref2.playerTool,
          _ref2$time = _ref2.time,
          time = _ref2$time === void 0 ? 0 : _ref2$time,
          _ref2$duration = _ref2.duration,
          _duration = _ref2$duration === void 0 ? Infinity : _ref2$duration;

      var _a;

      var recorder = isPlayScore ? (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.recorder : undefined;

      if (recorder && !recorder.onprogress) {
        recorder.onprogress = function () {
          var currentTime = playerTool.now() > 200 ? playerTool.now() - 200 : 0;

          if (currentTime > 0 && currentTime >= startTime.value) {
            recorder.currentTime = currentTime / 1000;
          } else {
            recorder.currentTime = undefined;
          }
        };
      }

      currentTime.value = time;
      duration.value = _duration;
    },
    ON_ERROR: function ON_ERROR() {
      console.log('ON_ERROR');
    },
    ON_DESTORYED: function ON_DESTORYED(playerTool) {
      console.log('ON_DESTORYED');
      isPlaying.value = false;
      playerTool.plugin.$highlight.disable(); // playerTool.plugin.$openAreaSelection.reset();
    },
    ON_FLUIDSYNTHJS_LOAD_STATE: function ON_FLUIDSYNTHJS_LOAD_STATE(_ref3) {
      var state = _ref3.state;
      console.log('ON_FLUIDSYNTHJS_LOAD_STATE', state);
    },
    ON_STOP_ACC_AUDIO: function ON_STOP_ACC_AUDIO(_ref4) {
      var _accAudio = _ref4.accAudio;
      console.log('ON_STOP_ACC', _accAudio);
      accAudio.value = _accAudio;
    }
  });
  var Mp3LoadResult = (0, _vue.computed)(function () {
    var _playMode = playMode.value;

    if (_playMode === _types.PlayMode.ori) {
      if (preFetchAudioOK.oriAudioOk.fetching) {
        alertTips.showMessage('info', '范唱音频下载中，请稍后！');
      }

      if (!preFetchAudioOK.oriAudioOk.result) {
        alertTips.showMessage('warning', '范唱音频不存在或者下载失败，无法播放，请重新加载或检查网络');
      }

      var result = preFetchAudioOK.oriAudioOk.result && !preFetchAudioOK.oriAudioOk.fetching;

      if (result) {
        alertTips.hideMessage();
      }

      return result;
    } else if (_playMode === _types.PlayMode.acc) {
      if (preFetchAudioOK.accAudioOk.fetching) {
        alertTips.showMessage('info', '伴唱音频下载中，请稍后！');
      }

      if (!preFetchAudioOK.accAudioOk.result) {
        alertTips.showMessage('warning', '伴唱音频不存在或者下载失败，无法播放，请重新加载或检查网络');
      }

      var _result = preFetchAudioOK.accAudioOk.result && !preFetchAudioOK.accAudioOk.fetching;

      if (_result) {
        alertTips.hideMessage();
      }

      return _result;
    } else {
      alertTips.hideMessage();
    }

    return true;
  }); // const getLoadMP3Result = () => {};
  // const isPartShow = computed(() => {
  //   const length = playParms.partInfo.length;
  //   const noShowLength = playParms.partInfo.filter(part => !part.show).length;
  //   return noShowLength === length;
  // });

  var isCanPlay = (0, _vue.computed)(function () {
    var _a;

    return Mp3LoadResult.value && !!((_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.viewer) && // !isPartShow.value &&
    !tempoPitchIng.value && !isPlayingPrepose.value && !isPresetting.value;
  });
  (0, _vue.watch)(function () {
    return isCanPlay.value;
  }, function (newVal) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;

    if (!newVal) {
      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$openAreaSelection.disable();

      if (playParms.closeAreaSelection) {
        (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$closeAreaSelection.disableClick();
      }
    } else {
      if (playState.value !== 'stop') {
        return;
      }

      if (!playParms.closeAreaSelection) {
        (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$closeAreaSelection.disable();
        (_d = sheetMusicBusiness.value) === null || _d === void 0 ? void 0 : _d.plugin.$openAreaSelection.enable();
      } else {
        (_e = sheetMusicBusiness.value) === null || _e === void 0 ? void 0 : _e.plugin.$closeAreaSelection.enable();
        (_f = sheetMusicBusiness.value) === null || _f === void 0 ? void 0 : _f.plugin.$closeAreaSelection.enableClick();
        (_g = sheetMusicBusiness.value) === null || _g === void 0 ? void 0 : _g.plugin.$openAreaSelection.disable();
      }
    }

    if (isPlaying.value && isPlayScore) {
      (_h = sheetMusicBusiness.value) === null || _h === void 0 ? void 0 : _h.plugin.$openAreaSelection.disable();

      if (playParms.closeAreaSelection) {
        (_j = sheetMusicBusiness.value) === null || _j === void 0 ? void 0 : _j.plugin.$closeAreaSelection.disableClick();
      }
    }
  });
  (0, _vue.watch)(function () {
    return isPlaying.value;
  }, function (newVal) {
    var _a, _b;

    if (isPlayScore && newVal) {
      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$openAreaSelection.disable();

      if (playParms.closeAreaSelection) {
        (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$closeAreaSelection.disableClick();
      }
    }
  }, {
    immediate: true
  });
  (0, _vue.watch)(function () {
    return isPlayingPrepose.value;
  }, function (newVal) {
    if (newVal) {
      setTimeout(function () {
        //! 准备过程中，超过3s，才提示播放准备中
        isPlayingPrepose.value && alertTips.showMessage('info', '播放准备中，请稍后。');
      }, 3000);
    } else {
      setTimeout(function () {
        alertTips.hideMessage();
        alertTips.reset();
      }, 500);
    }
  });
  (0, _vue.watch)(function () {
    return playState.value;
  }, function (newVal) {
    onPlayStateChange(newVal);
    onCloseAreaSelectionEnableClick(newVal);
    onCloseAreaSelectionShow(newVal);
    onOpenAreaSelectionScroll(newVal);
  });
  (0, _vue.watch)(function () {
    return dragStartTime.value;
  }, function (newVal) {
    var _a;

    if (newVal !== undefined) {
      openAreaRange.length = 0;
      var playerTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool; // const _startTime = playParms.isPreReadyTime ? preReadyTime.value : startTime.value;
      // if (newVal * 1000 < _startTime) {
      //   playerTool && playerTool.dragStart(_startTime);
      // } else {
      //   playerTool && playerTool.dragStart(newVal * 1000);
      // }

      playerTool && playerTool.dragStart(newVal * 1000);

      if (playParms.meodly) {
        playerTool.plugin.$colvinMelodyRender.unPauseMelodyAnimate();
        playerTool.plugin.$colvinMelodyRender.showMelodyToAnimate();
        playerTool.plugin.$colvinMelodyRender.setMelodyAnimateEnable(false);
      }
    }
  }); // 重置状态回到可播放

  var resetPlayingToStop = function resetPlayingToStop() {
    var _a;

    isPlaying.value = false;
    playState.value = _types.PlayState.stop;
    resetPlayTime();
    var playerTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool; // playerTool.plugin.$colvinMelodyRender.setMelodyAnimateEnable(true);

    if (playerTool) {
      playerTool.plugin.$highlight.disable();

      if (playParms.meodly) {
        playerTool.plugin.$colvinMelodyRender.unPauseMelodyAnimate();
        playerTool.plugin.$colvinMelodyRender.showMelodyToAnimate();
      }

      if (isPlayScore && !playParms.closeAreaSelection) {
        playerTool.plugin.$openAreaSelection.enable();
      }
    }
  };

  var playerStart = function playerStart(range) {
    return new Promise(function (resolve, reject) {
      if (!isPlayScore) {
        resolve('');
        return;
      }

      initPlayScore().then(function () {
        var _a, _b;

        var recordScoreTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.recordScoreTool;

        if (recordScoreTool) {
          // 设置评分等级
          var setLevel = _lodash.default.parseInt(playScoreParams.scoreLevel ? playScoreParams.scoreLevel : '0');

          recordScoreTool.setScoreLevel(setLevel);
          var partName = 'P' + playScoreParams.scorePart;
          var timeParams = (0, _extends2.default)((0, _extends2.default)({}, _types.recorderTimeParamsMap[playMode.value]), {
            isNeedLude: playScoreParams.scoreType === 0 ? false : true,
            playBackSpeed: playParms.speed
          });

          var _range = range !== null && range !== void 0 ? range : [0, 9];

          var pitchInfo = (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.getPitchInfo({
            partName: partName
          }, timeParams, _range[0], _range[1]);

          if (pitchInfo.length === 0) {
            reject('recordScore getPitch error');
            setIsRecordScoreing(false); // fixme 因为前面有个播放准备中，因此延时1s后显示

            setTimeout(function () {
              alertTips.showMessage('error', '评分异常，请重试');
              setTimeout(function () {
                alertTips.hideMessage();
              }, 1500);
            }, 1000);
            resetPlayingToStop();
            return;
          }

          recordScoreTool.setPitchInfo(pitchInfo);
          recordScoreTool.start().then(function () {
            recordScoreTool.pause();
            recordScoreTool.getScoreRealTime();
            resolve('');
          });
        } else {
          resetPlayingToStop();
          reject('recordScoreTool no found');
        }
      }).catch(function (e) {
        console.error(e);
        reject('init recorderScore error');
        setIsRecordScoreing(false); // fixme 因为前面有个播放准备中，因此延时1s后显示

        setTimeout(function () {
          alertTips.showMessage('error', '评分异常，请重试');
          setTimeout(function () {
            alertTips.hideMessage();
          }, 1500);
        }, 1000);
        resetPlayingToStop();
      });
    });
  };

  var onPlayStateChange = function onPlayStateChange(platState) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _a, _b, _c, _d, _e, _f, playerTool, _playerTool, _playerTool2, _playerTool3;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('on play state change', playState.value);
              /**
               * 1. 判断是否需要更新playerTool
               */
              // todo： 判断是否需要切换playerTool，ab段需要判断是否选者没有选者 要切回midi，要设置音色库的模式

              _context2.t0 = platState;
              _context2.next = _context2.t0 === 'start' ? 4 : _context2.t0 === 'pause' ? 21 : _context2.t0 === 'continue' ? 25 : _context2.t0 === 'stop' ? 29 : 32;
              break;

            case 4:
              isPlayingPrepose.value = true;
              _context2.prev = 5;
              _context2.next = 8;
              return awaitHandleTempoAndPitch();

            case 8:
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t1 = _context2["catch"](5);
              console.error(11111, _context2.t1);

            case 13:
              playParms.url = tempoPitchSoundUrl.value; // 获取（mp3）播放地址

              _context2.next = 16;
              return changePlayerTool(playMode.value);

            case 16:
              playerTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool; //! 更改 midi模式 无论是MP3还是MIDI最好都执行下

              _context2.next = 19;
              return changeSynthManagerPlayMode(playMode.value);

            case 19:
              playerTool.prepare(playParms).then(function () {
                return getRange();
              }).then(function (range) {
                console.log('rangeeeeeeeeee start:', range);
                return playerStart(range).then(function () {
                  return playerTool.start(range);
                }).then(function () {
                  var _a;

                  if (isPlayScore) {
                    var recordScoreTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.recordScoreTool;
                    recordScoreTool.continue();
                  }
                });
              }).finally(function () {
                isPlayingPrepose.value = false;
              }); // playerTool.prepare(playParms).then(() => {
              //   const range = getRange();
              //   playerStart(range)
              //     .then(() => playerTool.start(range))
              //     .then(() => {
              //       if (isPlayScore) {
              //         const recordScoreTool = sheetMusicBusiness.value?.recordScoreTool;
              //         recordScoreTool.continue();
              //       }
              //       isPlayingPrepose.value = false;
              //     });
              //   // todo:处理ab端播放 需要统一拿到range
              //   // !isPlayScore &&
              // });

              return _context2.abrupt("break", 33);

            case 21:
              _playerTool = (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.playerTool;

              _playerTool.pause();

              playParms.meodly && ((_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$colvinMelodyRender.pauseMelodyAnimate());
              return _context2.abrupt("break", 33);

            case 25:
              _playerTool2 = (_d = sheetMusicBusiness.value) === null || _d === void 0 ? void 0 : _d.playerTool; // todo:处理ab端播放 需要统一拿到range

              _playerTool2.setConfParams(playParms).then(function () {
                var range = getRange();
                console.log('rangeeeeeeeee:', range);

                _playerTool2.continue(range);
              });

              playParms.meodly && ((_e = sheetMusicBusiness.value) === null || _e === void 0 ? void 0 : _e.plugin.$colvinMelodyRender.unPauseMelodyAnimate());
              return _context2.abrupt("break", 33);

            case 29:
              _playerTool3 = (_f = sheetMusicBusiness.value) === null || _f === void 0 ? void 0 : _f.playerTool;

              _playerTool3.stop();

              return _context2.abrupt("break", 33);

            case 32:
              return _context2.abrupt("break", 33);

            case 33:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 10]]);
    }));
  };

  (0, _vue.watch)(function () {
    return playMode.value;
  }, function (newVal) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              onPlayModeChange(newVal);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  });

  var onPlayModeChange = function onPlayModeChange(playMode) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              /**
               * 1. 分辨是否选中了AB
               * 2. 更改playTool
               * 4. 重置参数
               * 5. 根据模式修改参数
               * 6. 设置音色库的模式
               *  点选 ab段选中
               * 7  播放时
               *      ab段不能选
               * 8    点选是可以
               *    不播放 都可以点选
               *  9
               * ! 可以在播放时全局设置playTool
               */
              loadObj.loading = true;
              _context4.prev = 1;
              resetPartInfo(); // 因为音色库的问题 需要重置音色库
              // resetPlayParms();

              resetPlayTime();
              _context4.next = 6;
              return setPlayParmsByPlayMode(playMode);

            case 6:
              _context4.next = 8;
              return configPitchBar();

            case 8:
              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](1);
              console.warn('onPlayModeChange', _context4.t0);

            case 13:
              _context4.prev = 13;
              loadObj.loading = false;
              return _context4.finish(13);

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 10, 13, 16]]);
    }));
  }; // 设置当前是否在评分状态


  var setIsPlayScore = function setIsPlayScore(state) {
    isPlayScore = state;
  };
  /**
   * 根据不同播放模式 设置不同的播放参数
   * @param playMode
   */


  var setPlayParmsByPlayMode = function setPlayParmsByPlayMode(playMode) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var _g, _h, song, sheetInfo;

      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(playMode === 'rhythm' && !asRhythm.value)) {
                _context5.next = 7;
                break;
              }

              if (playParms.colvin || playParms.meodly) {
                showColvinMeodly(playParms.colvin, playParms.meodly);
              }

              _context5.next = 4;
              return (_g = sheetMusicBusiness.value) === null || _g === void 0 ? void 0 : _g.setUserOption({
                asRhythm: true
              });

            case 4:
              asRhythm.value = true; // 节奏模式 开启节拍器都需要重置ab段
              // resetCloseAreaSelection();

              _context5.next = 12;
              break;

            case 7:
              if (!(playMode !== 'rhythm' && asRhythm.value)) {
                _context5.next = 12;
                break;
              }

              if (playParms.colvin || playParms.meodly) {
                showColvinMeodly(playParms.colvin, playParms.meodly);
              }

              _context5.next = 11;
              return (_h = sheetMusicBusiness.value) === null || _h === void 0 ? void 0 : _h.setUserOption({
                asRhythm: false
              });

            case 11:
              asRhythm.value = false; // resetCloseAreaSelection();

            case 12:
              song = playParms.song, sheetInfo = playParms.sheetInfo;
              _context5.t0 = playMode;
              _context5.next = _context5.t0 === 'ori' ? 16 : _context5.t0 === 'acc' ? 22 : _context5.t0 === 'rhythm' ? 28 : _context5.t0 === 'midiNoVolume' ? 30 : _context5.t0 === 'midi' ? 32 : _context5.t0 === 'rollCall' ? 34 : 36;
              break;

            case 16:
              if (playParms.oriFileBuffer) {
                _context5.next = 19;
                break;
              }

              console.warn('no find oriFileUrl');
              return _context5.abrupt("return");

            case 19:
              //fixed: 因为切换了播放类型，所以无需传变速变调值，使用默认值
              handleTempoAndPitch(playParms.oriFileBuffer, playParms.song.oriFileUrl, playParms.pitchSemitones, playParms.tempo);
              (0, _extends2.default)(playParms, {
                // speed: song.speed || sheetInfo.speed,
                speed: (playParms === null || playParms === void 0 ? void 0 : playParms.speed) === playParms.sourceSpeed ? song.speed || sheetInfo.speed : playParms === null || playParms === void 0 ? void 0 : playParms.speed,
                sourceSpeed: song.speed || sheetInfo.speed,
                isNoVolume: false
              });
              return _context5.abrupt("break", 37);

            case 22:
              if (playParms.accFileBuffer) {
                _context5.next = 25;
                break;
              }

              console.warn('no find accFileUrl');
              return _context5.abrupt("return");

            case 25:
              //fixed: 因为切换了播放类型，所以无需传变速变调值，使用默认值
              handleTempoAndPitch(playParms.accFileBuffer, playParms.song.accFileUrl, playParms.pitchSemitones, playParms.tempo);
              (0, _extends2.default)(playParms, {
                speed: (playParms === null || playParms === void 0 ? void 0 : playParms.speed) === playParms.sourceSpeed ? song.accSpeed || sheetInfo.speed : playParms === null || playParms === void 0 ? void 0 : playParms.speed,
                sourceSpeed: song.accSpeed || sheetInfo.speed,
                isNoVolume: false
              });
              return _context5.abrupt("break", 37);

            case 28:
              (0, _extends2.default)(playParms, {
                url: undefined,
                speed: (playParms === null || playParms === void 0 ? void 0 : playParms.speed) === playParms.sourceSpeed ? sheetInfo.speed : playParms === null || playParms === void 0 ? void 0 : playParms.speed,
                sourceSpeed: sheetInfo.speed,
                isRhythm: true,
                isNoVolume: false
              });
              return _context5.abrupt("break", 37);

            case 30:
              (0, _extends2.default)(playParms, {
                url: undefined,
                // speed: sheetInfo.speed,
                speed: (playParms === null || playParms === void 0 ? void 0 : playParms.speed) === playParms.sourceSpeed ? sheetInfo.speed : playParms === null || playParms === void 0 ? void 0 : playParms.speed,
                sourceSpeed: sheetInfo.speed,
                isNoVolume: true
              });
              return _context5.abrupt("break", 37);

            case 32:
              (0, _extends2.default)(playParms, {
                url: undefined,
                // speed: sheetInfo.speed,
                speed: (playParms === null || playParms === void 0 ? void 0 : playParms.speed) === playParms.sourceSpeed ? sheetInfo.speed : playParms === null || playParms === void 0 ? void 0 : playParms.speed,
                sourceSpeed: sheetInfo.speed,
                isNoVolume: false,
                isRhythm: false
              });
              return _context5.abrupt("break", 37);

            case 34:
              (0, _extends2.default)(playParms, {
                url: undefined,
                // speed: sheetInfo.speed,
                speed: (playParms === null || playParms === void 0 ? void 0 : playParms.speed) === playParms.sourceSpeed ? sheetInfo.speed : playParms === null || playParms === void 0 ? void 0 : playParms.speed,
                sourceSpeed: sheetInfo.speed,
                isNoVolume: false,
                isRhythm: false
              });
              return _context5.abrupt("break", 37);

            case 36:
              return _context5.abrupt("break", 37);

            case 37:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
  };
  /**
   * 更改播放工具
   * @param playMode
   */


  var changePlayerTool = function changePlayerTool(playMode) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      var _j, _k, isMp3, playerToolType, closeAreaSelection;

      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              isMp3 = playMode === _types.PlayMode.ori || playMode === _types.PlayMode.acc;
              playerToolType = null;
              closeAreaSelection = playParms.closeAreaSelection;

              if (closeAreaSelection && (closeAreaRange.value.length === 0 || closeAreaRange.value[0] === 0 && closeAreaRange.value[1] === 0) || ((_j = closeAreaRange.value) === null || _j === void 0 ? void 0 : _j[1]) === 0 || closeAreaRange.value[0] === -1) {
                closeAreaSelection = false;
              }

              if (isMp3) {
                playerToolType = closeAreaSelection ? _utils.PlayerToolType.Mp3_AB : _utils.PlayerToolType.Mp3;
              } else {
                playerToolType = closeAreaSelection ? _utils.PlayerToolType.Midi_AB : _utils.PlayerToolType.Midi;
              }

              if (!(currentPlayerToolType !== playerToolType)) {
                _context6.next = 9;
                break;
              }

              _context6.next = 8;
              return (_k = sheetMusicBusiness.value) === null || _k === void 0 ? void 0 : _k.changePlayerTool(playerToolType);

            case 8:
              currentPlayerToolType = playerToolType;

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  };
  /** 变更音色库模式 */


  var changeSynthManagerPlayMode = function changeSynthManagerPlayMode(playMode) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee7() {
      var _l, mode;

      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              mode = playMode === _types.PlayMode.rollCall ? 1 : 0;
              _context7.next = 3;
              return (_l = sheetMusicBusiness.value) === null || _l === void 0 ? void 0 : _l.playerTool.setPlayMode(mode);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  };
  /** 处理播放选项 */


  var playerOptions = function playerOptions() {
    var _a;

    if (jsBridge) {
      jsBridge.registerHandler('setCallBackEvent', function (dataStr) {
        var _a, _b;

        var data = JSON.parse(dataStr) || {};
        (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool.playerCallBack((_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.state);
      });
    }

    var loadFluidsynthjsProgress = function loadFluidsynthjsProgress(progress) {
      if (progress.percentage < 100) {
        loadObj.loading = true;
        loadObj.loadingTip = "\u6B63\u5728\u4E0B\u8F7D\u97F3\u8272\u5E93".concat(progress.percentage, "%");
      } else {
        loadObj.loading = false;
        loadObj.loadingTip = loadObj.loadingText;
      }
    };

    return {
      playerType: jsBridge ? 'fluidsynth' : 'fluidsynthjs',
      loadFluidsynthjsSoundFont: window.h5Version >= '1.2.0' || ((_a = window) === null || _a === void 0 ? void 0 : _a.Electron) ? loadFluidsynthjsSoundFont : '',
      loadFluidsynthjsProgress: loadFluidsynthjsProgress
    };
  };
  /** 处理播放插件 */


  var pluginOptions = function pluginOptions() {
    return {
      OpenAreaSelection: {
        enable: true,
        init: function init(plugin) {
          plugin.onReady(function (range) {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee8() {
              return _regenerator.default.wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      areaSelect.value = true;
                      _context8.next = 3;
                      return onOpenAreaSelectionReady(range);

                    case 3:
                      plugin.show();
                      setTimeout(function () {
                        areaSelect.value = false;
                      }, 0);

                    case 5:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8);
            }));
          });
        }
      },
      CloseAreaSelection: {
        enable: true,
        init: function init(plugin) {
          plugin.onReady(function (range) {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee9() {
              return _regenerator.default.wrap(function _callee9$(_context9) {
                while (1) {
                  switch (_context9.prev = _context9.next) {
                    case 0:
                      // todo: 处理显示与不显示
                      areaSelect.value = true;
                      _context9.next = 3;
                      return onCloseAreaSelectionReady(range);

                    case 3:
                      setTimeout(function () {
                        areaSelect.value = false;
                      }, 0);

                    case 4:
                    case "end":
                      return _context9.stop();
                  }
                }
              }, _callee9);
            }));
          });
          plugin.onError(function (errorType) {
            var _a; // 0-其他错误 ，1-ab只能选择音符，2-ab只能选择歌词，3-ab不符合规则播放


            showABErrorTips(errorType);
            playState.value = _types.PlayState.stop; // isAreaSelectCurrent.value = false;
            // 错误类型为1和2时，A框选未清空，不需要滚动回顶部

            if (errorType === 1 || errorType === 2) {
              (_a = plugin.$highlight) === null || _a === void 0 ? void 0 : _a.scrollToTop(false);
            }
          });
          plugin.onClearSelected(function () {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee10() {
              return _regenerator.default.wrap(function _callee10$(_context10) {
                while (1) {
                  switch (_context10.prev = _context10.next) {
                    case 0:
                      console.log('closeArea clear');
                      closeAreaRange.value.length = 0;
                      closeAreaRange.value.push(-1);

                    case 3:
                    case "end":
                      return _context10.stop();
                  }
                }
              }, _callee10);
            }));
          });
        }
      },
      ColvinMelodyRender: {
        enable: true
      }
    };
  };
  /**
   * 点选会触发到直接播放
   * @param range
   */


  var onOpenAreaSelectionReady = function onOpenAreaSelectionReady() {
    var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _a;

    openAreaRange.length = 0;
    openAreaRange.push.apply(openAreaRange, (0, _toConsumableArray2.default)(range));
    var playerTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool;
    var state = playerTool.state;
    /**
     * 1. 还没播放就点选
     * 2. 正在播放还点选
     * 3. 暂停还在点选
     */

    if (!isPlaying.value) {
      playState.value = _types.PlayState.start;
    } else if (isPlaying.value && state !== _types.PlayState.pause && state !== _types.PlayState.continue) {
      playState.value = _types.PlayState.continue;
    } else if (isPlaying.value && state === _types.PlayState.continue) {
      onPlayStateChange(_types.PlayState.continue);
    } else {
      playState.value = _types.PlayState.continue;
    }
  };
  /**
   * 停止播放后 不是ab的话 就要滚动到顶部
   * @param playState
   */


  var onOpenAreaSelectionScroll = function onOpenAreaSelectionScroll(playState) {
    var _a, _b, _c;

    if (!playParms.closeAreaSelection && playState === _types.PlayState.stop) {
      (_b = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$highlight) === null || _b === void 0 ? void 0 : _b.scrollToTop(false);
      (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$openAreaSelection.reset();
    }
  };

  var onCloseAreaSelectionEnableClick = function onCloseAreaSelectionEnableClick(playState) {
    var _a, _b;

    if (playState !== _types.PlayState.stop) {
      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$closeAreaSelection.disableClick();
    } else {
      (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$closeAreaSelection.enableClick();
    }
  };

  var onCloseAreaSelectionShow = function onCloseAreaSelectionShow(playState) {
    var _a, _b, _c, _d, _e;

    if (playParms.closeAreaSelection && (closeAreaRange.value.length === 0 || closeAreaRange.value[0] === -1) || ((_a = closeAreaRange.value) === null || _a === void 0 ? void 0 : _a[1]) === 0) {
      if (playState !== _types.PlayState.stop) {
        playState === _types.PlayState.start && ((_c = (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$highlight) === null || _c === void 0 ? void 0 : _c.scrollToTop(true));
        (_d = sheetMusicBusiness.value) === null || _d === void 0 ? void 0 : _d.plugin.$closeAreaSelection.hide();
      } else {
        (_e = sheetMusicBusiness.value) === null || _e === void 0 ? void 0 : _e.plugin.$closeAreaSelection.show();
      }
    }
  };
  /**
   * 点选完 只负责赋值
   * @param range
   */


  var onCloseAreaSelectionReady = function onCloseAreaSelectionReady() {
    var _closeAreaRange$value;

    var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    closeAreaRange.value.length = 0;

    (_closeAreaRange$value = closeAreaRange.value).push.apply(_closeAreaRange$value, (0, _toConsumableArray2.default)(range));

    isAreaSelectCurrent.value = true;
  };

  var showABErrorTips = function showABErrorTips(errorType) {
    ABErrorTips.value = _types.ABErrorMessage[errorType];
    setTimeout(function () {
      ABErrorTips.value = '';
    }, 2000);
  };

  var getRange = function getRange() {
    var _a;

    var closeAreaSelection = playParms.closeAreaSelection;

    if (closeAreaSelection && (closeAreaRange.value.length === 0 || closeAreaRange.value[0] === 0 && closeAreaRange.value[1] === 0) || ((_a = closeAreaRange.value) === null || _a === void 0 ? void 0 : _a[1]) === 0 || closeAreaRange.value[0] === -1) {
      closeAreaSelection = false;
    }

    if (closeAreaSelection) {
      return playState.value === _types.PlayState.continue ? null : closeAreaRange.value;
    } else if (openAreaRange.length > 0) {
      return openAreaRange;
    } //! 判断如果是处于暂停状态 准备重新播放的时候 就是要返回null


    return playState.value === _types.PlayState.continue ? null : [0];
  };

  var stopPlay = function stopPlay() {
    var _a, _b;

    playParms.closeAreaSelection = false;
    (_b = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool) === null || _b === void 0 ? void 0 : _b.destroyed();
  };

  var resetPlayTime = function resetPlayTime() {
    currentTime.value = 0;
    duration.value = 0;
    dragStartTime.value = undefined;
  }; // 重置播放模式


  var resetPlayMode = function resetPlayMode() {
    var _a, _b;

    var _playMode = _types.PlayMode.ori;

    if (!((_a = playParms.song) === null || _a === void 0 ? void 0 : _a.oriFileUrl)) {
      _playMode = _types.PlayMode.acc;
    }

    if (_playMode === _types.PlayMode.acc && !((_b = playParms.song) === null || _b === void 0 ? void 0 : _b.accFileUrl)) {
      _playMode = _types.PlayMode.midi;
    }

    playMode.value = _playMode;
  };

  var resetPlayParms = function resetPlayParms() {
    closeAreaRange.value.length = 0;

    _lodash.default.merge(playParms, {
      isBeat: false,
      isPreReadyTime: true,
      isNoVolume: false,
      isRhythm: false,
      keySignature: undefined,
      sourcekeySignature: undefined,
      partInfo: [],
      speed: undefined,
      sourceSpeed: undefined,
      tempo: 1,
      pitchSemitones: 0,
      fullSheet: false,
      showLyrics: true,
      showMetronomeSignature: true,
      closeAreaSelection: false,
      colvin: false,
      meodly: false,
      rollCall: false // 唱名

    });

    playParms.sourcekeySignature = playParms.sheetInfo.keySignature;
    playParms.keySignature = playParms.sheetInfo.keySignature;
    playParms.sourceSpeed = playParms.sheetInfo.speed;
    playParms.speed = playParms.sheetInfo.speed;
    playParms.partInfo = _lodash.default.cloneDeep(playParms.sheetInfo.partInfo);
  }; // const resetCloseAreaSelection = () => {
  //   resetPlayTime();
  //   // closeAreaRange.length = 0;
  //   sheetMusicBusiness.value?.plugin.$closeAreaSelection.reset();
  //   isCanPlay.value
  //     ? sheetMusicBusiness.value?.plugin.$closeAreaSelection.enableClick()
  //     : sheetMusicBusiness.value?.plugin.$closeAreaSelection.disableClick();
  // };
  // 重新渲染旋律线


  var reRenderMelody = function reRenderMelody() {
    var _a, _b;

    if (playParms.meodly) {
      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$colvinMelodyRender.resetColvinMelodys();
      (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$colvinMelodyRender.showMeodly();
    }
  }; // 重新渲染AB选段


  var reLoadCloseAreaSelection = function reLoadCloseAreaSelection() {
    var _a, _b, _c;

    if (!closeAreaRange.value || closeAreaRange.value.length === 0 || ((_a = closeAreaRange.value) === null || _a === void 0 ? void 0 : _a[0]) === -1) {
      return;
    }

    (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$closeAreaSelection.enable();
    (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$closeAreaSelection.renderRange(closeAreaRange.value);
  };

  var resetOpenAreaSelection = function resetOpenAreaSelection() {
    openAreaRange.length = 0;
  };

  var resetPartInfo = function resetPartInfo() {// playParms.partInfo.map((item: any) => {
    //   item.instrument = 0;
    // });
  }; // watchEffect(() => {
  //   if (playParms.closeAreaSelection) {
  //     sheetMusicBusiness.value?.plugin.$openAreaSelection.disable();
  //     isCanPlay.value && sheetMusicBusiness.value?.plugin.$closeAreaSelection.enable();
  //   } else {
  //     sheetMusicBusiness.value?.plugin.$openAreaSelection.enable();
  //     sheetMusicBusiness.value?.plugin.$closeAreaSelection.disable();
  //   }
  // });


  (0, _vue.watch)(function () {
    return playParms.closeAreaSelection;
  }, function () {
    var _a, _b, _c, _d;

    if (playParms.closeAreaSelection) {
      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$openAreaSelection.disable();
      isCanPlay.value && ((_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$closeAreaSelection.enable());
    } else {
      (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$openAreaSelection.enable();
      (_d = sheetMusicBusiness.value) === null || _d === void 0 ? void 0 : _d.plugin.$closeAreaSelection.disable();
    }
  });
  (0, _vue.watch)(function () {
    var _a;

    return (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin;
  }, function () {
    var _a, _b;

    if ((_a = sheetMusicBusiness.value.plugin) === null || _a === void 0 ? void 0 : _a.$openAreaSelection) {
      !isCanPlay.value && sheetMusicBusiness.value.plugin.$openAreaSelection.disable();
    }

    if ((_b = sheetMusicBusiness.value.plugin) === null || _b === void 0 ? void 0 : _b.$closeAreaSelection) {
      !isCanPlay.value && sheetMusicBusiness.value.plugin.$closeAreaSelection.disable();
    }
  });

  var initSheetPlugin = function initSheetPlugin(plugin) {
    plugin.$highlight.enable();

    if (playParms.closeAreaSelection) {
      plugin.$openAreaSelection.disable();
    }
  };

  var initPlayParms = function initPlayParms() {
    return new Promise(function (resolve, reject) {
      var _a, _b, _c, _d, _e;

      try {
        var _speed = props.playMode === 'ori' ? (_a = props === null || props === void 0 ? void 0 : props.song) === null || _a === void 0 ? void 0 : _a['speed'] : (_b = props === null || props === void 0 ? void 0 : props.song) === null || _b === void 0 ? void 0 : _b['accSpeed'];

        (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.initPlayerTool(playEvents.value, undefined);
        playParms.sheetInfo = ((_d = sheetMusicBusiness.value) === null || _d === void 0 ? void 0 : _d.getSheetBasic()) || {};
        playParms.sheetInfo.keySignature = playParms.sheetInfo.keySignature.replace('#', 's');
        playParms.sourceSpeed = _speed || playParms.sheetInfo.speed;
        playParms.speed = _speed || playParms.sheetInfo.speed;
        playParms.sourcekeySignature = playParms.sheetInfo.keySignature;
        playParms.keySignature = playParms.sheetInfo.keySignature;
        playParms.sheetInfo.partInfo = (((_e = sheetMusicBusiness.value) === null || _e === void 0 ? void 0 : _e.getMultiPart().scoreparts) || []).map(function (part) {
          var hideParts = playParms.sheetInfo.hideParts;
          (0, _extends2.default)(part, {
            show: !hideParts.includes(part.name),
            showName: _utils.partMap[part.name.replace('P', '')],
            volume: 1,
            sourceVolume: 1
          });
          return part;
        });
        playParms.partInfo = _lodash.default.cloneDeep(playParms.sheetInfo.partInfo);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  };

  var playModes = (0, _vue.computed)(function () {
    var _a, _b;

    var _playModes = [{
      label: '范唱',
      value: 'ori'
    }, {
      label: '伴唱',
      value: 'acc'
    }, {
      label: '演奏',
      value: 'midiNoVolume'
    }, {
      label: '曲谱',
      value: 'midi'
    }, {
      label: '唱名',
      value: 'rollCall'
    }];

    if (!((_a = playParms === null || playParms === void 0 ? void 0 : playParms.song) === null || _a === void 0 ? void 0 : _a.oriFileUrl)) {
      _playModes = _playModes.filter(function (playMode) {
        return playMode.value !== 'ori';
      });
    }

    if (!((_b = playParms === null || playParms === void 0 ? void 0 : playParms.song) === null || _b === void 0 ? void 0 : _b.accFileUrl)) {
      _playModes = _playModes.filter(function (playMode) {
        return playMode.value !== 'acc';
      });
    }

    return _playModes;
  });

  var initPlayMode = function initPlayMode() {
    var _a, _b;

    if (playMode.value === _types.PlayMode.ori && !((_a = playParms.song) === null || _a === void 0 ? void 0 : _a.oriFileUrl)) {
      playMode.value = _types.PlayMode.acc;
    }

    if (playMode.value === _types.PlayMode.acc && !((_b = playParms.song) === null || _b === void 0 ? void 0 : _b.accFileUrl)) {
      playMode.value = _types.PlayMode.midi;
    }

    if (playState.value === 'stop') {
      onPlayModeChange(playMode.value);
    }
  };

  var showColvinMeodly = function showColvinMeodly(colvin, meodly) {
    var _a, _b, _c, _d, _e, _f, _g, _h; // 涉及更新曲谱时，需要重置数据，再次打开展示手势和旋律线


    if (colvin || meodly) {
      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$colvinMelodyRender.resetColvinMelodys();
      (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$colvinMelodyRender.enable(); // sheetMusicBusiness.value?.plugin.$colvinMelodyRender.setMelodyLineColor('#fff');
      // sheetMusicBusiness.value?.plugin.$colvinMelodyRender.setMelodyLineWidth('9');
      // sheetMusicBusiness.value?.plugin.$colvinMelodyRender.setMelodyLineImage(
      //   'http://127.0.0.1:8080/heart.png',
      // );
    } // 同时开启柯尔文和旋律线


    if (colvin && meodly) {
      (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$colvinMelodyRender.show();
    } else if (colvin) {
      // 只开启柯尔文
      (_d = sheetMusicBusiness.value) === null || _d === void 0 ? void 0 : _d.plugin.$colvinMelodyRender.hideMeodly();
      (_e = sheetMusicBusiness.value) === null || _e === void 0 ? void 0 : _e.plugin.$colvinMelodyRender.showColvin();
    } else if (meodly) {
      // 只开启旋律线
      (_f = sheetMusicBusiness.value) === null || _f === void 0 ? void 0 : _f.plugin.$colvinMelodyRender.hideColvin();
      (_g = sheetMusicBusiness.value) === null || _g === void 0 ? void 0 : _g.plugin.$colvinMelodyRender.showMeodly();
    } else {
      (_h = sheetMusicBusiness.value) === null || _h === void 0 ? void 0 : _h.plugin.$colvinMelodyRender.disable();
    }
  };

  var showRollCall = function showRollCall(rollCall) {
    var _a, _b;

    if (rollCall) {
      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$rollCallRender.enable();
    } else {
      (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$rollCallRender.disable();
    }
  };

  var enablePitchBar = function enablePitchBar(pitchBar) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee11() {
      var _m, _o;

      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!pitchBar) {
                _context11.next = 6;
                break;
              }

              _context11.next = 3;
              return configPitchBar();

            case 3:
              (_m = sheetMusicBusiness.value) === null || _m === void 0 ? void 0 : _m.plugin.$pitchBarRender.enable();
              _context11.next = 7;
              break;

            case 6:
              (_o = sheetMusicBusiness.value) === null || _o === void 0 ? void 0 : _o.plugin.$pitchBarRender.disable();

            case 7:
              _context11.next = 9;
              return refreshSheet();

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
  };

  var configPitchBar = function configPitchBar() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee12() {
      var _p, _q, partName, timeParams;

      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              partName = 'P' + playScoreParams.scorePart;
              timeParams = (0, _extends2.default)((0, _extends2.default)({}, _types.recorderTimeParamsMap[playMode.value]), {
                isNeedLude: playScoreParams.scoreType === 0 ? false : true,
                // isNeedSrcTime: false,
                playBackSpeed: playParms.speed
              });
              (_p = sheetMusicBusiness.value) === null || _p === void 0 ? void 0 : _p.plugin.$pitchBarRender.getPitchNotes(partName, timeParams, {
                isGrace: true,
                isChord: true,
                isStaccato: true,
                isMordent: true,
                isTrill: true,
                isTieMerge: false,
                isRapNeedPitch: true
              });

              if (!(playScoreParams.pitchBar && !isPresetting.value)) {
                _context12.next = 6;
                break;
              }

              _context12.next = 6;
              return (_q = sheetMusicBusiness.value) === null || _q === void 0 ? void 0 : _q.refreshSheet();

            case 6:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
  };

  var refreshSheet = _lodash.default.debounce(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee13() {
      var _r, _s, _t;

      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              console.log('refreshSheet');
              _context13.next = 3;
              return (_r = sheetMusicBusiness.value) === null || _r === void 0 ? void 0 : _r.refreshSheet();

            case 3:
              playParms.closeAreaSelection && reLoadCloseAreaSelection();
              (_s = sheetMusicBusiness.value) === null || _s === void 0 ? void 0 : _s.setFullSheet(playParms.fullSheet);

              if (!playParms.fullSheet) {
                (_t = sheetMusicBusiness.value) === null || _t === void 0 ? void 0 : _t.scaleTo(sheetMusicEl.value.offsetWidth / 1920);
              }

              isPresetting.value = false;
              loadObj.loadingTip = loadObj.loadingText;
              setTimeout(function () {
                loadObj.loading = false;
              }, 500);

            case 9:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));
  }, 250);

  (0, _vue.watch)(function () {
    return loadObj.loading;
  }, function () {
    if (!loadObj.loading && isPresetting.value) {
      loadObj.loading = true;
      loadObj.loadingTip = '设置预设参数中...';
    }
  });
  var isLockWatchPlayParms = (0, _vue.ref)(false);
  (0, _vue.watch)(function () {
    return [playParms.isBeat, playParms.isRhythm, playParms.showLyrics, playParms.fullSheet, playParms.colvin, playParms.meodly, playParms.rollCall, playParms.showMetronomeSignature, playScoreParams === null || playScoreParams === void 0 ? void 0 : playScoreParams.pitchBar];
  }, _lodash.default.debounce(function (_ref5, _ref6) {
    var _ref7 = (0, _slicedToArray2.default)(_ref5, 9),
        isBeat = _ref7[0],
        isRhythm = _ref7[1],
        showLyrics = _ref7[2],
        fullSheet = _ref7[3],
        colvin = _ref7[4],
        meodly = _ref7[5],
        rollCall = _ref7[6],
        showMetronomeSignature = _ref7[7],
        pitchBar = _ref7[8];

    var _ref8 = (0, _slicedToArray2.default)(_ref6, 9),
        _oldIsBeat = _ref8[0],
        _oldIsRhythm = _ref8[1],
        _oldShowLyrics = _ref8[2],
        _oldFullSheet = _ref8[3],
        _oldColvin = _ref8[4],
        _oldMeodly = _ref8[5],
        _oldRollCall = _ref8[6],
        _oldShowMetronomeSignature = _ref8[7],
        _oldPitchBar = _ref8[8];

    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee14() {
      var _u, _v, _w, _x, _y, _z, _0, _1, _2, selParts;

      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              isLockWatchPlayParms.value = true;
              loadObj.loading = true;
              loadObj.loadingTip = isPresetting.value ? '设置预设参数中...' : loadObj.loadingText;
              _context14.next = 5;
              return (0, _vue.nextTick)();

            case 5:
              selParts = [];
              (_u = playParms.partInfo) === null || _u === void 0 ? void 0 : _u.forEach(function (part) {
                part.show && selParts.push(part.name);
              });
              showRollCall(rollCall); // showColvinMeodly(colvin, meodly);

              (_v = sheetMusicBusiness.value) === null || _v === void 0 ? void 0 : _v.showBeats(isBeat, selParts);
              (_w = sheetMusicBusiness.value) === null || _w === void 0 ? void 0 : _w.showLyrics(showLyrics);

              if (isRhythm !== _oldIsRhythm) {
                isRhythm && (playParms.isBeat = false);
                (_x = sheetMusicBusiness.value) === null || _x === void 0 ? void 0 : _x.showBeats(playParms.isBeat, selParts);
              }

              if (isBeat !== _oldIsBeat) {
                isBeat && (playParms.isRhythm = false);
              }

              if (!playParms.isRhythm) {
                _context14.next = 17;
                break;
              }

              _context14.next = 15;
              return sheetMusicBusiness.value.setUserOption({
                asRhythm: true
              }, undefined, false);

            case 15:
              _context14.next = 19;
              break;

            case 17:
              _context14.next = 19;
              return sheetMusicBusiness.value.setUserOption({
                asRhythm: false
              }, undefined, false);

            case 19:
              if (!playParms.showMetronomeSignature) {
                _context14.next = 24;
                break;
              }

              _context14.next = 22;
              return sheetMusicBusiness.value.setUserOption({
                showMetronomeSignature: true
              }, undefined, false);

            case 22:
              _context14.next = 26;
              break;

            case 24:
              _context14.next = 26;
              return sheetMusicBusiness.value.setUserOption({
                showMetronomeSignature: false
              }, undefined, false);

            case 26:
              if (!pitchBar) {
                _context14.next = 32;
                break;
              }

              _context14.next = 29;
              return configPitchBar();

            case 29:
              (_y = sheetMusicBusiness.value) === null || _y === void 0 ? void 0 : _y.plugin.$pitchBarRender.enable();
              _context14.next = 33;
              break;

            case 32:
              if (pitchBar === false && _oldPitchBar === true) {
                (_z = sheetMusicBusiness.value) === null || _z === void 0 ? void 0 : _z.plugin.$pitchBarRender.disable();
              }

            case 33:
              if (!(showMetronomeSignature !== _oldShowMetronomeSignature)) {
                _context14.next = 36;
                break;
              }

              _context14.next = 36;
              return (_0 = sheetMusicBusiness.value) === null || _0 === void 0 ? void 0 : _0.refreshSheetHeader();

            case 36:
              if (!(isBeat !== _oldIsBeat || isRhythm !== _oldIsRhythm || showLyrics !== _oldShowLyrics || colvin !== _oldColvin || meodly !== _oldMeodly || rollCall !== _oldRollCall || showMetronomeSignature !== _oldShowMetronomeSignature || pitchBar || pitchBar === false && _oldPitchBar === true)) {
                _context14.next = 44;
                break;
              }

              showColvinMeodly(colvin, meodly);
              console.log('exce refresh'); // await sheetMusicBusiness.value?.refreshSheet();

              _context14.next = 41;
              return refreshSheet();

            case 41:
              isLockWatchPlayParms.value = false;
              _context14.next = 50;
              break;

            case 44:
              (_1 = sheetMusicBusiness.value) === null || _1 === void 0 ? void 0 : _1.setFullSheet(fullSheet);

              if (!fullSheet) {
                (_2 = sheetMusicBusiness.value) === null || _2 === void 0 ? void 0 : _2.scaleTo(sheetMusicEl.value.offsetWidth / 1920);
              }

              isLockWatchPlayParms.value = false;
              isPresetting.value = false;
              loadObj.loadingTip = loadObj.loadingText;
              setTimeout(function () {
                loadObj.loading = false;
              }, 500);

            case 50:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));
  }, 1000, {
    leading: true,
    trailing: true
  })); // * 监听大调

  (0, _vue.watch)(function () {
    return playParms.keySignature;
  }, _lodash.default.debounce(function (newVal, oldVal) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee15() {
      var _3, skeySignaturesValue, nowKeySignatureIndex, sourceKeySignatureIndex, pitchSemitones, realPitchSemitones;

      return _regenerator.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (!(oldVal === newVal || !oldVal)) {
                _context15.next = 2;
                break;
              }

              return _context15.abrupt("return");

            case 2:
              skeySignaturesValue = (0, _dataMap.getSourceKeySignaturesOptions)(playParms.sourcekeySignature).map(function (i) {
                return i.value;
              }) || [];
              nowKeySignatureIndex = skeySignaturesValue.indexOf(replaceKeySignatures(playParms.keySignature));
              sourceKeySignatureIndex = skeySignaturesValue.indexOf(playParms.sourcekeySignature);
              pitchSemitones = sourceKeySignatureIndex - nowKeySignatureIndex;
              realPitchSemitones = getRealPitchSemitones(playParms.keySignature, pitchSemitones);
              playParms.pitchSemitones = realPitchSemitones;
              (_3 = sheetMusicBusiness.value) === null || _3 === void 0 ? void 0 : _3.editSheet({
                keySignature: replaceKeySignatures(newVal)
              }, getOctaveOffset(newVal));
              reRenderMelody();

              if (isLockWatchPlayParms.value) {
                _context15.next = 13;
                break;
              }

              _context15.next = 13;
              return refreshSheet();

            case 13:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));
  }, 100));

  var getOctaveOffset = function getOctaveOffset(pitch) {
    if (pitch.indexOf('@') === 0) {
      return -1;
    } else if (pitch.indexOf('$') === 0) {
      return 1;
    }

    return 0;
  };

  (0, _vue.watch)(function () {
    return playParms.displayMode;
  }, function (newVal) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee16() {
      var _4;

      return _regenerator.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              // 切换显示模式时如果旋律线开启重新获取旋律线信息
              reRenderMelody(); // 保存曲谱显示模式到 localStorage

              localStorage.setItem('displayMode', newVal);
              _context16.next = 4;
              return (_4 = sheetMusicBusiness.value) === null || _4 === void 0 ? void 0 : _4.setDisplayMode(newVal);

            case 4:
              // 重新渲染AB段
              playParms.closeAreaSelection && reLoadCloseAreaSelection();

            case 5:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));
  });

  var replaceKeySignatures = function replaceKeySignatures(key) {
    return key.replace('@', '').replace('$', '');
  };

  var getRealPitchSemitones = function getRealPitchSemitones(key, pitchSemitones) {
    if (key.indexOf('@') === 0) {
      return pitchSemitones - 12;
    } else if (key.indexOf('$') === 0) {
      return pitchSemitones + 12;
    }

    return pitchSemitones;
  }; // * 监听速度


  (0, _vue.watch)(function () {
    return playParms.speed;
  }, function (newVal, oldVal) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee17() {
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              if (!(oldVal === newVal || !oldVal)) {
                _context17.next = 2;
                break;
              }

              return _context17.abrupt("return");

            case 2:
              playParms.tempo = playParms.speed / playParms.sourceSpeed; // resetCloseAreaSelection();

              _context17.next = 5;
              return configPitchBar();

            case 5:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));
  }); //* 隐藏声部，因为跟音量挂钩了，因此使用every来判断是否是show字段改变

  (0, _vue.watch)(function () {
    return _lodash.default.cloneDeep(playParms.partInfo);
  }, function (newVal, oldVal) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee18() {
      var _5, _6, _7, _8, result, hideParts, selParts;

      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (!(oldVal.length === 0)) {
                _context18.next = 2;
                break;
              }

              return _context18.abrupt("return");

            case 2:
              result = _lodash.default.every(newVal, function (item) {
                var oldItem = oldVal.find(function (old) {
                  return old.name === item.name;
                });
                return oldItem.show === item.show;
              });

              if (result) {
                _context18.next = 17;
                break;
              }

              loadObj.loading = true;
              loadObj.loadingTip = loadObj.loadingText;
              hideParts = newVal.filter(function (item) {
                return !item.show;
              }).filter(Boolean).map(function (item) {
                return item.name;
              });
              selParts = newVal.filter(function (item) {
                return item.show;
              }).filter(Boolean).map(function (item) {
                return item.name;
              }); //! 显隐声部会影响节拍器的渲染 因此要更新下节拍器内部信息

              (_5 = sheetMusicBusiness.value) === null || _5 === void 0 ? void 0 : _5.updateBeats(selParts);
              (_6 = sheetMusicBusiness.value) === null || _6 === void 0 ? void 0 : _6.setUserOption({
                hideParts: hideParts
              }, undefined, false);
              showColvinMeodly(playParms.colvin, playParms.meodly); // await sheetMusicBusiness.value?.refreshSheet();

              _context18.next = 13;
              return refreshSheet();

            case 13:
              //! 可能显隐声部时，全谱的状态时开启的
              (_7 = sheetMusicBusiness.value) === null || _7 === void 0 ? void 0 : _7.setFullSheet(playParms.fullSheet);

              if (!playParms.fullSheet) {
                (_8 = sheetMusicBusiness.value) === null || _8 === void 0 ? void 0 : _8.scaleTo(sheetMusicEl.value.offsetWidth / 1920);
              } // resetCloseAreaSelection();


              playParms.closeAreaSelection && reLoadCloseAreaSelection();
              setTimeout(function () {
                loadObj.loading = false;
              }, 300);

            case 17:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));
  });

  var destroyMp3 = function destroyMp3() {
    if (playParms === null || playParms === void 0 ? void 0 : playParms.oriFileBuffer) {
      window.URL.revokeObjectURL(playParms.oriFileBuffer);
    }

    if (playParms === null || playParms === void 0 ? void 0 : playParms.accFileBuffer) {
      window.URL.revokeObjectURL(playParms.accFileBuffer);
    }
  };
  /**
   * 下载变更为buffer
   * @returns
   */


  var fetchMp3 = function fetchMp3() {
    return new Promise(function (resolve, reject) {
      var song = playParms.song;
      var fetchPromise = [];

      if (song === null || song === void 0 ? void 0 : song.oriFileUrl) {
        fetchPromise.push(new Promise(function (resolve) {
          preFetchAudioOK.oriAudioOk.fetching = true;
          resolve();
        }).then(function () {
          return (0, _utils.fetchBuffer)(song === null || song === void 0 ? void 0 : song.oriFileUrl);
        }).then(function (oriAudioBuffer) {
          playParms.oriFileBuffer = oriAudioBuffer;
          preFetchAudioOK.oriAudioOk.result = true;
        }).catch(function () {
          preFetchAudioOK.oriAudioOk.result = false;
        }).finally(function () {
          return preFetchAudioOK.oriAudioOk.fetching = false;
        }));
      } else {
        preFetchAudioOK.oriAudioOk.result = false;
      }

      if (song === null || song === void 0 ? void 0 : song.accFileUrl) {
        fetchPromise.push(new Promise(function (resolve) {
          preFetchAudioOK.accAudioOk.fetching = true;
          resolve();
        }).then(function () {
          return (0, _utils.fetchBuffer)(song === null || song === void 0 ? void 0 : song.accFileUrl);
        }).then(function (accAudioBuffer) {
          playParms.accFileBuffer = accAudioBuffer;
          preFetchAudioOK.accAudioOk.result = true;
        }).catch(function () {
          preFetchAudioOK.accAudioOk.result = false;
        }).finally(function () {
          return preFetchAudioOK.accAudioOk.fetching = false;
        }));
      } else {
        preFetchAudioOK.accAudioOk.result = false;
      }

      return Promise.all(fetchPromise).then(resolve).catch(reject);
    });
  };

  (0, _vue.watchEffect)(function () {
    if (tempoPitchIng.value) {
      var stretchProgressNum = Math.floor(tempoPitchProgress.value * 100) / 100 * 100;
      alertTips.showMessage('info', "\u53D8\u901F\u53D8\u8C03\u8F6C\u6362\u4E2D\uFF0C\u8BF7\u7A0D\u540E\uFF01\u8FDB\u5EA6:".concat(stretchProgressNum.toFixed(0), "%"));
    } else {
      alertTips.hideMessage();
    }
  });
  var oldPreviewParams = undefined; // 监听预设参数变化

  var onChangePreviewParams = _lodash.default.debounce(function (previewParams) {
    var _a, _b, _c;

    var _ref9 = (previewParams === null || previewParams === void 0 ? void 0 : previewParams.detail) || {},
        playParams = _ref9.playParams,
        _closeAreaRange = _ref9.closeAreaRange,
        _playMode = _ref9.playMode,
        _playScoreParams = _ref9.playScoreParams;

    if (_lodash.default.isEqual(previewParams === null || previewParams === void 0 ? void 0 : previewParams.detail, oldPreviewParams)) {
      return;
    }

    oldPreviewParams = _lodash.default.cloneDeep(previewParams === null || previewParams === void 0 ? void 0 : previewParams.detail);
    isPresetting.value = true;
    loadObj.loading = true;
    loadObj.loadingTip = '设置预设参数中...'; // 重置参数

    if (!((_a = previewParams === null || previewParams === void 0 ? void 0 : previewParams.detail) === null || _a === void 0 ? void 0 : _a.playParams)) {
      console.log('曲谱播放参数重置');
      resetPlayMode();
      resetPlayParms();
      setTimeout(function () {
        isPresetting.value = false;
        loadObj.loading = false;
        loadObj.loadingTip = loadObj.loadingText;
      }, 100);
      return;
    }

    var _d = playParams || {},
        partInfo = _d.partInfo,
        displayMode = _d.displayMode,
        _playParams = __rest(_d, ["partInfo", "displayMode"]); // displayMode 目前先不做预设


    playMode.value = _playMode; // 曲谱速度可能修改，导致与预设保存的原速度不一致 => 若出现此情况，速度改回原速

    var preSpeed = _playParams.speed;
    var isExitSpeed = _dataMap.speeds.filter(function (speed) {
      return speed.value === preSpeed;
    }).length > 0;

    if (preSpeed !== playParms.sourceSpeed && !isExitSpeed) {
      _playParams.speed = playParms.sourceSpeed;
    }

    var oldPlayParms = _lodash.default.cloneDeep(playParms);

    if (playParams) {
      _lodash.default.merge(playParms, _playParams);

      _lodash.default.merge(playParms.partInfo, partInfo);
    }

    _lodash.default.merge(playScoreParams, _playScoreParams);

    if (playParms.colvin || playParms.meodly) {
      playScoreParams.pitchBar = false;
    } // 若有选择AB选段，需渲染


    if (_closeAreaRange && (_closeAreaRange === null || _closeAreaRange === void 0 ? void 0 : _closeAreaRange[0]) !== -1) {
      var _closeAreaRange$value2;

      closeAreaRange.value.length = 0;

      (_closeAreaRange$value2 = closeAreaRange.value).push.apply(_closeAreaRange$value2, (0, _toConsumableArray2.default)(_closeAreaRange));

      if (playParms.closeAreaSelection) {
        (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.plugin.$closeAreaSelection.enable();
        (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$closeAreaSelection.renderRange(closeAreaRange.value);
      }
    }

    setTimeout(function () {
      if (!isLockWatchPlayParms.value && isPresetting.value) {
        isPresetting.value = false;
        loadObj.loading = false;
        loadObj.loadingTip = loadObj.loadingText;
      }
    }, 100); // 若范唱、伴唱模式有变速变调，需重新生成

    if (oldPlayParms.tempo !== playParms.tempo || oldPlayParms.pitchSemitones !== playParms.pitchSemitones.value) {
      if (playMode.value === 'ori') {
        window.requestIdleCallback(function () {
          return handleTempoAndPitch(playParms.oriFileBuffer, playParms.song.oriFileUrl, playParms.pitchSemitones, playParms.tempo);
        });
      } else if (playMode.value === 'acc') {
        window.requestIdleCallback(function () {
          return handleTempoAndPitch(playParms.accFileBuffer, playParms.song.accFileUrl, playParms.pitchSemitones, playParms.tempo);
        });
      }
    }
  }, 200);

  (0, _vue.onMounted)(function () {
    window.addEventListener(_types.PreviewParamsEvent.CHANGE_PREVIEW_PARAMS, onChangePreviewParams);
  });
  (0, _vue.onBeforeUnmount)(function () {
    if (playParms.oriFileBuffer) {
      playParms.oriFileBuffer = undefined;
    }

    if (playParms.accFileBuffer) {
      playParms.accFileBuffer = undefined;
    }

    window.removeEventListener(_types.PreviewParamsEvent.CHANGE_PREVIEW_PARAMS, onChangePreviewParams);
  });
  return {
    playParms: playParms,
    closeAreaRange: closeAreaRange,
    preFetchAudioOK: preFetchAudioOK,
    isPlaying: isPlaying,
    isCanPlay: isCanPlay,
    playMode: playMode,
    playModes: playModes,
    playState: playState,
    duration: duration,
    currentTime: currentTime,
    isAreaSelectCurrent: isAreaSelectCurrent,
    ABErrorTips: ABErrorTips,
    accAudio: accAudio,
    startTime: startTime,
    preReadyTime: preReadyTime,
    dragStartTime: dragStartTime,
    getRange: getRange,
    playerOptions: playerOptions,
    pluginOptions: pluginOptions,
    fetchMp3: fetchMp3,
    initPlayParms: initPlayParms,
    initPlayMode: initPlayMode,
    stopPlay: stopPlay,
    setIsPlayScore: setIsPlayScore,
    showColvinMeodly: showColvinMeodly,
    destroyMp3: destroyMp3,
    enablePitchBar: enablePitchBar,
    configPitchBar: configPitchBar
  };
};

exports.default = _default;